// extracted by mini-css-extract-plugin
module.exports = {"checkboxBlock":"style_checkboxBlock__0WYmI","checkboxBlock__title":"style_checkboxBlock__title__EmwC6","checkboxBlock__list":"style_checkboxBlock__list__Kl57c"};